import { createContext } from "react";
import type {
  CreatePickupPayload,
  Pickup,
  UpdatePickupPayload,
} from "../../../api/pickups";

// This is what we use for fetching, creating, updating and deleting pickups.

export interface PickupContextType {
  pickups: Pickup[];
  loading: boolean;
  error: string | null;
  fetchPickups: () => Promise<void>;
  createPickup: (data: CreatePickupPayload) => Promise<void>;
  updatePickup: (id: string, data: UpdatePickupPayload) => Promise<void>;
  deletePickup: (id: string) => Promise<void>;
  refreshPickups: () => Promise<void>;
}

export const PickupContext = createContext<PickupContextType>({
  pickups: [],
  loading: false,
  error: null,
  fetchPickups: () => Promise.resolve(),
  createPickup: () => Promise.resolve(),
  updatePickup: () => Promise.resolve(),
  deletePickup: () => Promise.resolve(),
  refreshPickups: () => Promise.resolve(),
});
